<div
  #specificContainer
  class="iu-specific-window iu-specific-window-container operation-management-window no-overflow-x"
  [attr.data-cy-specific-window-name]="name">
  <div style="height: 20px">
    <a class="settings" (click)="isSidebarOpen = !isSidebarOpen">
      <i class="fas fa-cog" aria-hidden="true"></i>
    </a>
  </div>
  <!-- ganttHeight - 20 : le 20 est le padding/margin du container à retirer -->
  <iu-gantt
    (filterChange)="onFilterChange($event)"
    (pageChange)="onPageChange($event)"
    [actualPage]="actualPage"
    [buildCalendar]="buildCalendar"
    [columns]="columns"
    [dateFormat]="ganttDateFormat"
    [dragConfig]="dragConfiguration"
    [ganttData$]="ganttData$"
    [ganttHeight]="specificContainer.clientHeight - 40"
    [gridRowClass]="gridRowClass"
    [gridWidth]="gridWidth"
    [hasUniversalFilter]="true"
    [levelZoom]="GanttZoomLevel.DAY"
    [maximumPage]="!lastRow ? -1 : maximumPage"
    [onAfterTaskDrag]="onAfterTaskDrag"
    [onBeforeTaskDrag]="onBeforeTaskDrag"
    [onTaskOpened]="onOFOpened"
    [paginationEnable]="paginationEnable"
    [setFilterEmitter]="setFilterEmitter"
    [showCollapseButton]="false"
    [showExpandButton]="false"
    [showRedoButton]="false"
    [showUndoButton]="false"
    [taskClass]="taskClass"
    [taskRowClass]="gridRowClass"
    [taskText]="taskText"
    [uf_columns]="uf_columns"
    [uf_formId]="fields[0].formDetailId"
    [uf_isStandalone]="true" />

  <p-sidebar
    [(visible)]="isSidebarOpen"
    [baseZIndex]="0"
    position="right"
    styleClass="p-sidebar-md optionalFilterPanel">
    <h1 class="iu-notification-center-title">
      {{ 'specificWindow.optionalFilters' | translate }}
    </h1>
    <div class="optionalFields">
      <ng-template #optional />
      @for (column of _columns | objectArrayFilter: ['!_empty_', 'name']; track $index) {
        <div>
          <iu-input-switch-ui
            [isStandalone]="true"
            [fieldValue]="column.show ? 'Y' : 'N'"
            (fieldValueModified)="updateDisplayColumns(column.name, $event)"
            [label]="column.label" />
        </div>
      }

      <div>
        <p>{{ 'planning-window.Legend' | translate }}</p>
        <div class="color-legend gantt-task-OF">{{ 'planning-window.legend.OF' | translate }}</div>
        <div class="color-legend gantt-task-OP">{{ 'planning-window.legend.OP' | translate }}</div>
        <div class="color-legend gantt-task-subcontract">{{ 'planning-window.legend.subcontract' | translate }}</div>
      </div>
    </div>
  </p-sidebar>
</div>
